"use strict";

require("normalize.css");

require("./index.css");